import { useTranslation } from "react-i18next";
import { useGlobal } from "../../context/GlobalContext";
import LocalesList from "../others/LocalesList";
import { useSettings } from "../../context/SettingsContext";
import EToolTip from "../others/EToolTip";

// Пагінатори для обнулення при зміні локалізаційного фільра
const resetPaginators = ['/pages', '/blog'];

const LocaleFilter = () => {

    const { t } = useTranslation();
    const { g } = useGlobal();
    const { settings } = useSettings();

    
 
    // Зміна локалізаційного фільтра
    const handleChange = (opt) => {
        // Змінюємо фільтра і таргетимо оновлення 
        g.setLocaleFilter(opt.value);
        g.setTarget(!g.target); 

        // Обнуллюємо залежні від локалізаційного фільтра пагінатори
        const _paginator = {...g.paginator};
        resetPaginators.forEach(pLocate => {
            if (_paginator?.[pLocate])
                _paginator[pLocate].currentPage = 1;
        });
        g.setPaginator(_paginator)        
    }
 
    if (!(settings?.site?.locales?.trim()||null)) return null;

    return (
        <EToolTip title={t('LocaleFilter.title')}
            placement="right"> 
        <div className="ps-3 text-start"  
            style={{minWidth:'100px', width:'100%'}}>
            <LocalesList
                onChange={handleChange}
                emptyTitle={t('LocaleFilter.allLocales')}
                value={g.localeFilter}/>
            
        </div>
        </EToolTip>)    
}

export default LocaleFilter;
 